var cookiePopup;
var webStatsCheckbox;

var ccMessage = 'Wir verwenden Cookies';
var ccMessage2 = 'Weitere Informationen dazu finden Sie in unseren';
var ccDismiss = 'Auswahl bestätigen';
var ccLink = 'Datenschutzhinweisen.';
var ccHref = 'https://www.lsi-bochum.de/datenschutz/';
var techCookiesLabel = 'Technisch notwendige Cookies';
var statCookiesText = 'Damit Sie unsere Webseiten optimal nutzen können, verwenden wir technische Cookies. Mithilfe von Statistik-Cookies erfassen wir anonymisiert Nutzerdaten, um unsere Inhalte und die Nutzerfreundlichkeit unserer Seiten fortlaufend für Sie zu verbessern.';
var statCookiesLabel = 'Statistik Cookies';
var acceptAll = 'Alles bestätigen';

if (document.documentElement.lang.substring(0, 2) === 'en') {
    ccMessage = 'We use Cookies';
    ccMessage2 = 'You can find more information in our';
    ccDismiss = 'Confirm selection';
    ccLink = 'privacy policy.';
    ccHref = 'https://www.lsi-bochum.de/en/data-protection-advisory/';
    techCookiesLabel = 'technically necessary Cookies';
    statCookiesText = 'We use technical cookies so that you can use our website faultless. Marketing cookies collect anonymous user data. They help us to improve our content and to reach you via online marketing.';
    statCookiesLabel = 'Web analysis';
    acceptAll = 'Select all';
}

var ccMessageLink = '' +
    '   <div id="cookieconsent:desc" class="cc-message"><h3>{{message}}</h3>' +
    '       <div class="cookie-options">\n' +
    '            <label>\n' +
    '                ' + statCookiesText + '\n' +
    '            </label><br><br>\n' +
    '            <input type="checkbox" name="essenziell" value="essenziell" checked="checked" disabled="">\n' +
    '            <label>\n' +
    '                ' + techCookiesLabel + '\n' +
    '            </label><br>\n' +
    '            <input type="checkbox" id="check-web-statistic" name="check-web-statistic" value="analytcis">\n' +
    '            <label for="check-web-statistic">\n' +
    '                ' + statCookiesLabel + '\n' +
    '            </label><br><br>\n' +
    '            <label for="check-web-statistic">\n' +
    '                ' + ccMessage2 + ' <a  href="' + ccHref + '" target="_self">' + ccLink + '</a>' + '\n' +
    '            </label><br><br>\n' +
    '        </div>' +
    '   </div>';

cookieconsent.utils.isMobile = function() {
    return false
}

cookieconsent.initialise({
    "content": {
        "message": ccMessage,
        "dismiss": ccDismiss
    },
    "elements": {
        "dismiss": '<span aria-label="dismiss cookie message" tabindex="0" class="cc-btn cc-dismiss accept-as-is">{{dismiss}}</span><span class="cc-btn cc-dismiss accept-all">' + acceptAll + '</span>',
        "messagelink": ccMessageLink
    },
    onPopupOpen: function (status) {
        webStatsCheckbox = document.querySelector('input[name="check-web-statistic"]');
        if(getCookie('track_web_statistics') !== '') {
            webStatsCheckbox.checked = true;
        }
        document.querySelector('.accept-all').addEventListener('click', (e) => {
            document.querySelectorAll('.cookie-options input[type="checkbox"]').forEach(function(el) {
                el.checked = true;
            })
        })

        //set blur effect
        document.querySelector('body').classList.add('blurAll');
    },
    onStatusChange: function (status) {
        if (webStatsCheckbox.checked === true) {
            setCookie('track_web_statistics', 'true', 10000);
            startWebTracking();
        } else {
            var domainsToRemove = ['www.lsi-bochum.de', '.lsi-bochum.de', '.lsi-bochum.de.local', '.de.local'];

            for(var i = 0; i < domainsToRemove.length; i++) {
                clearCookie('_ga', domainsToRemove[i]);
                clearCookie('_gid', domainsToRemove[i]);
                clearCookie('_gat', domainsToRemove[i]);
            }
            clearCookie('ga');
            clearCookie('track_web_statistics');
        }

        document.querySelector('body').classList.remove('blurAll');
    },
    onInitialise: function (status) {
        if (this.hasConsented()) {
            if(getCookie('track_web_statistics') !== '') {
                startWebTracking();
            }
        } else {
            cookiePopup.open();
        }
    },
}, function (popup) {
    cookiePopup = popup;
}, function (err) {
    console.error(err);
});

if (document.querySelectorAll('.cookie-layer-link').length > 0) {
    document.querySelector('.cookie-layer-link').addEventListener('click', (e) => {
        e.preventDefault();
        cookiePopup.open();
    })
}

function clearCookie(nameStartsWith, domain, path){
    var a_all_cookies = document.cookie.split(';');
    for ( i = 0; i < a_all_cookies.length; i++ ) {
        var a_temp_cookie = a_all_cookies[i].split( '=' );
        // and trim left/right whitespace while we're at it
        var cookie_name = a_temp_cookie[0].replace(/^\s+|\s+$/g, '');
        if (cookie_name.indexOf(nameStartsWith) === 0) {
            var domainPart = '';
            //in order to be able to remove
            //cookies from current domain we must not define domain by setting cookie!!!
            if (domain && domain !== document.domain && domain !== '') {
                domainPart = '; domain=' + domain + ';';
            }
            var path = path || '/';
            var setCookie = cookie_name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;' + domainPart + ' path=' + path;
            document.cookie = setCookie;
        }
    }
}

function startWebTracking() {
    var _paq = window._paq = window._paq || [];
    /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
    _paq.push(['trackPageView']);
    _paq.push(['enableLinkTracking']);
    (function() {
        var u="https://matomo.ruhr-uni-bochum.de/";
        _paq.push(['setTrackerUrl', u+'matomo.php']);
        _paq.push(['setSiteId', '85']);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.type='text/javascript';
        g.async=true;
        g.src=u+'matomo.js';
        s.parentNode.insertBefore(g,s);
    })();
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}